import api from '@/services/api';

export function listAssessments({
    page = 1,
    limit = 20,
    topic = '',
    teacherId = null,
    subjectId = null,
    studentId = null,
    feedbackLetterId = null
} = {}) {
    const params = new URLSearchParams({ page, limit });
    if (topic) params.set('topic', topic);
    if (Number.isFinite(Number(teacherId)) && Number(teacherId) > 0) {
        params.set('teacher_id', String(Number(teacherId)));
    }
    if (Number.isFinite(Number(subjectId)) && Number(subjectId) > 0) {
        params.set('subject_id', String(Number(subjectId)));
    }
    if (Number.isFinite(Number(studentId)) && Number(studentId) > 0) {
        params.set('student_id', String(Number(studentId)));
    }
    if (Number.isFinite(Number(feedbackLetterId)) && Number(feedbackLetterId) > 0) {
        params.set('feedback_letter_id', String(Number(feedbackLetterId)));
    }
    return api.get(`/feedback-assessments?${params.toString()}`).then(r => r.data);
}

export function listReleasedAssessmentsForStudent({studentId, feedbackLetterId}) {
    const sid = Number(studentId);
    const lid = Number(feedbackLetterId);

    if (!Number.isFinite(sid) || sid <= 0) {
        return Promise.reject(new Error('studentId ungültig'));
    }
    if (!Number.isFinite(lid) || lid <= 0) {
        return Promise.reject(new Error('feedbackLetterId ungültig'));
    }

    const params = new URLSearchParams({feedback_letter_id: String(lid)});
    return api.get(`/feedback-assessments/students/${sid}?${params.toString()}`).then(r => r.data);
}

export function getAssessment(id) {
    return api.get(`/feedback-assessments/${id}`).then(r => r.data);
}

export function createAssessment(payload) {
    return api.post('/feedback-assessments', payload).then(r => r.data);
}

export function updateAssessment(id, payload) {
    return api.put(`/feedback-assessments/${id}`, payload).then(r => r.data);
}

export function deleteAssessment(id) {
    return api.delete(`/feedback-assessments/${id}`).then(r => r.data);
}